/** @format */

import {ReactElement, useEffect, useState} from 'react';

import {styled} from '@mui/material/styles';

import {Box, Button, Grow, Typography} from '@mui/material';

const PREFIX = 'ActionBanner';

const classes = {
  containerNew: `${PREFIX}-containerNew`,
  innerNew: `${PREFIX}-innerNew`,
  textNew: `${PREFIX}-textNew`,
  buttonNew: `${PREFIX}-buttonNew`,
};

const StyledGrow = styled(Grow)(({theme}) => ({
  width: '100%',

  [`& .${classes.containerNew}`]: {
    position: 'relative',
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    padding: '16px',
    zIndex: ACTION_BANNER_Z_INDEX,
    background: '#AE5658',
    boxShadow: '1px 1px 5px 0px rgba(0, 0, 0, 0.05)',
  },

  [`& .${classes.innerNew}`]: {
    width: '936px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '0 auto',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      justifyContent: 'space-between',
    },
  },

  [`& .${classes.textNew}`]: {
    fontSize: '16px',
    fontWeight: 700,
  },

  [`& .${classes.buttonNew}`]: {
    padding: '16px',
    borderRadius: '8px',
    border: '1px solid #FFF',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 'normal',
  },
}));

export const ACTION_BANNER_Z_INDEX = 999;

interface Props {
  buttonText: string;
  text: string | ReactElement;
  onClick: () => void;
}

const ActionBanner = ({buttonText, onClick, text}: Props) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => setOpen(true), 100);
  }, []);

  return (
    <StyledGrow in={open}>
      <Box>
        <Box className={classes.containerNew}>
          <Box className={classes.innerNew}>
            <Typography className={classes.textNew}>{text}</Typography>
            <Button className={classes.buttonNew} fullWidth={false} onClick={onClick}>
              {buttonText}
            </Button>
          </Box>
        </Box>
      </Box>
    </StyledGrow>
  );
};

export default ActionBanner;
